import { Component, PipeTransform, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'iw-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})

export class IframeComponent implements OnInit {
  // Referencia de la modal
  modalRef: BsModalRef;
  @ViewChild('modlaIframe') private template: TemplateRef<any>;
  url = '';
  title = '';
   constructor(private modalService: BsModalService) { }
  ngOnInit() {
  }
  open(url: string, title: string, ) {
  this.url = url;
  this.title = title;
  this.modalRef = this.modalService.show(
    this.template,
    {
      class: 'modal-personalized',
      ignoreBackdropClick: true
    }
  );
  }
  onHide(e: boolean) {
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/utilidades-externas/iframe/iframe.component.ts